const state = {
  userId: null as string | null,
};

const getCurrentUserId = (): string | null => state.userId;
const setCurrentUserId = (userId: string | null): void => {
  state.userId = userId;
};

export { getCurrentUserId, setCurrentUserId };
